import { render, staticRenderFns } from "./RegistrationCompleted.vue?vue&type=template&id=14945649&scoped=true&"
import script from "./RegistrationCompleted.vue?vue&type=script&lang=ts&"
export * from "./RegistrationCompleted.vue?vue&type=script&lang=ts&"
import style0 from "./RegistrationCompleted.vue?vue&type=style&index=0&id=14945649&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14945649",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VImg,VRow,VSpacer})
